// Environment: staging

import { IEnvironment } from '@models/environment';
import versions from '../_versions';

const ENVIRONMENT = 'me';
const DEPLOYMENT_HOST = 'onclass.me';
const COOKIE_DOMAIN = '.onclass.me';
const API_ENDPOINTS_HOST = 'b.onclass.me';
const WS_HOST = 'wsweb.onclass.me';
const BFF_HOST = 'apiv2.onclass.me';
const AUTH_HOST = 'auth.onclass.me';
const ASSETS_HOST = 'cdn.onclass.me';

const BACKEND_HOST = 'onclass.me';
const WEBAPPS_HOST = 'onclass.me';

const I18N_HOST = 'i.onclass.me';
const RECAPTCHA_KEY = '0x4AAAAAAAxs1Dme0FscrzV8';
const SENTRY_DSN = 'https://b787a4c2568e79d16fd2ca73a1e8f97b@sentry.onclass.tech/2';
const TOLGEE_URL = 'https://devtools-tolgee.onclass.tech';
const TOLGEE_API_KEY = 'tgpak_gjpweyzzmu3tgyrrobwtontpnnuwen3kmzuw23zzoa3gy';

const INTERCONN_KEY = '136b483a-2314-4d16-80c6-6c4f17e7537b4';
const CRISP_WEBSITE_ID = '2ca1e19f-89ee-4892-9cb5-725c1949d64a';
const FIREBASE_KEY = 'AIzaSyA1QmWmvckFEHJrSBoT3qHFAfIsFfw-pts';
const WEBPUSH_KEY = 'BAyGkR979wY8yNOOx4y8V9ea6o3D7WSTOL8eYRJ6PUxUO5HpBIANNq8VhMdL3eRSVcU7Hdd39AvDsIok69ubYFQ';
const SENDBIRD_KEY = '67B48B78-63C2-43A2-9841-2B4F393C62B4';

const FB_ID = '1090157726279411';
const METRIKA_ID = '102325979';
const GA_ID = 'G-WN2B4LCH7N';

/*
 */
export const environment: IEnvironment = {
  access_token_key: 'APP_AUTH_ACCESS',
  refresh_token_key: 'APP_AUTH_REFRESH',
  auth_ic_our_routes: ['onclass.com', 'onclass.me', 'onclass.tech', 'onclass.space', 'onclass.local'],
  auth_ic_skip_routes: ['.css', '.js', 'assets/', 'web/auth/user-token', 'refresh', 'signout', 'signin'],

  env: `${ENVIRONMENT}`,
  production: false,
  store_debug: false,
  default_language: 'en',
  cookie_domain: COOKIE_DOMAIN || DEPLOYMENT_HOST,
  default_host: `https://${DEPLOYMENT_HOST}`,
  ssr_strip_scripts: true,

  interconn_key: INTERCONN_KEY,

  assets_url: `https://${ASSETS_HOST}/`,
  token_url: `https://${AUTH_HOST}`,
  auth_url: `https://${API_ENDPOINTS_HOST}/web/auth`,
  account_url: `https://${API_ENDPOINTS_HOST}/web/account`,
  content_url: `https://${API_ENDPOINTS_HOST}/web/content`,
  comment_url: `https://${API_ENDPOINTS_HOST}/web/comments`,
  files_url: `https://${API_ENDPOINTS_HOST}/web/files`,
  messaging_url: `https://${API_ENDPOINTS_HOST}/web/messaging`,
  notificator_url: `https://${API_ENDPOINTS_HOST}/notificator`,
  chat_url: `https://${API_ENDPOINTS_HOST}/web/chat`,
  ws_url: `wss://${WS_HOST}`,
  stripe_iframe_host: `https://${API_ENDPOINTS_HOST}/web/billing`,
  bff_url: `https://${BFF_HOST}`,
  billing_public_url: `https://${API_ENDPOINTS_HOST}/web/billing`,

  gamelib_app_host: `https://gamefe.${WEBAPPS_HOST}`,
  gamelib_app_api_host: `https://${API_ENDPOINTS_HOST}`,
  chat_app_host: `https://chatapp.${WEBAPPS_HOST}`,
  chat_app_api_host: `https://${API_ENDPOINTS_HOST}`,
  files_host: `https://fs.${BACKEND_HOST}`.replace(/\/?$/, '/'),
  files_storage_host: `https://fs.${BACKEND_HOST}/storage/`.replace(/\/?$/, '/'),
  // files_host: `https://cdn-fs.${BACKEND_HOST}`,

  tolgee_url: TOLGEE_URL,
  tolgee_api_key: TOLGEE_API_KEY,

  mobile_app_url: 'https://i76jk.app.link/onclass-com',
  crisp_website_id: CRISP_WEBSITE_ID,
  re_captcha_site_key: RECAPTCHA_KEY,
  builderio_api_key: SENDBIRD_KEY,
  sentry_dsn: SENTRY_DSN,
  sentrySampleRate: 0.0,
  sendbird_app_id: SENDBIRD_KEY,
  firebaseOptions: {
    apiKey: FIREBASE_KEY,
    authDomain: 'onclass-11649.firebaseapp.com',
    databaseURL: 'https://onclass-11649.firebaseio.com',
    projectId: 'onclass-11649',
    storageBucket: 'onclass-11649.appspot.com',
    messagingSenderId: '680468905548',
    appId: '1:680468905548:web:8ebd8b70aa0d3b7a3d3ee9',
  },
  webpush: {
    public_key: WEBPUSH_KEY,
  },

  // Analytics
  metrika_id: +METRIKA_ID,
  metrika_webvisor: true,
  ga_id: GA_ID,
  fb_id: FB_ID,

  versions,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
